var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "info_svg2__a",
    x1: 34.85,
    x2: 173.85,
    y1: 170.26,
    y2: 20.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#info_svg2__a",
    id: "info_svg2__b",
    x1: 42.78,
    x2: 181.78,
    y1: 177.6,
    y2: 27.6
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#info_svg2__a",
    id: "info_svg2__c",
    x1: 12.75,
    x2: 151.75,
    y1: 149.78,
    y2: -0.22
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M144.69 10.42h-.01C131.07 3.6 115.69 0 100.21 0 77.84 0 55.98 7.43 38.65 20.91 8.66 44.23-5.69 83.34 2.09 120.54c7.63 36.52 35.83 66.37 71.86 76.07A99.2 99.2 0 0 0 99.74 200c22.32 0 44.2-7.45 61.59-20.98 24.22-18.84 38.68-48.39 38.68-79.05 0-37.58-21.71-72.73-55.32-89.55m7.19 156.45c-14.71 11.43-33.23 17.73-52.15 17.73-7.4 0-14.73-.97-21.79-2.86-30.47-8.2-54.34-33.46-60.79-64.35-6.58-31.49 5.57-64.58 30.94-84.32 14.64-11.4 33.16-17.67 52.12-17.67 13.11 0 26.1 3.04 37.59 8.79 28.44 14.24 46.82 43.98 46.82 75.78 0 25.95-12.24 50.95-32.74 66.9",
    style: {
      fill: "url(#info_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 78.47c-4.89 0-8.85 3.97-8.85 8.86v57.05c0 4.89 3.96 8.86 8.85 8.86s8.86-3.97 8.86-8.86V87.33c0-4.89-3.96-8.86-8.86-8.86",
    style: {
      fill: "url(#info_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 46.76c-4.89 0-8.85 3.97-8.85 8.86s3.96 8.86 8.85 8.86 8.86-3.97 8.86-8.86-3.96-8.86-8.86-8.86",
    style: {
      fill: "url(#info_svg2__c)"
    }
  }));
};
export default SvgInfo;